<template>
  <div class="a-vs-b--bet-placing">
    <h3 id="bet-placing-header">{{$t('ticket')}}</h3>

    <div v-show="showError" class="quick-response">
      {{getPaymentErrorMessage()}}
    </div>

    <div class="a-vs-aside--bets">
      <simple-ticket
        class="a-vs-b--single-bet"
        v-for="ticket in picks"
        :key="ticket.EventID"
        :ticket="ticket"
        @onDelete="removePickedMatch(ticket)" />
    </div>

    <input-block
      ref="inputBlockElement"
      :picks="picks"
      v-model="money"
      :currentMoney="money"
      :config="config"
      :amount="amount"
      :errorIsShown="showError"
      @onDeleteAll="deleteAll()"/>
  </div>
</template>

<script>
import { eventBus } from '@/main.js'
import EventConstants from '@/constants/Events'
import NumberFormat from '@/mixins/NumberFormat'
import Vue from 'vue'
import VSoccerTicketHelper from '@/mixins/VSoccerTicketHelper'
import VSoccerHelper from '@/mixins/VSoccerHelper'
import InputBlock from '@/components/soccer/bet-place/InputBlock.vue'
import NetworkHelper from '@/mixins/NetworkHelper.js'

export default {
  components: {
    'input-block': InputBlock
  },
  mixins: [NumberFormat, VSoccerTicketHelper, VSoccerHelper, NetworkHelper],
  data () {
    return {
      picks: [],
      money: 1.00,
      showError: false
    }
  },
  props: {
    isBettingEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    config: {
      type: Object,
      required: true
    },
    amount: {
      type: Number
    }
  },
  watch: {
    config: function (val) {
      if (val && val.DefaultPayin) {
        this.money = val.DefaultPayin
      }
    },
    picks: function (val) {
      if (this.money < this.minValue) {
        this.money = this.minValue
      }
    }
  },
  methods: {
    sortTickerts () {
      this.picks.sort((e1, e2) => (e1.EventID % 1000) - (e2.EventID % 1000))
    },
    getPaymentErrorMessage () {
      if (this.$refs.inputBlockElement) {
        let element = this.$refs.inputBlockElement
        let message = element.getPaymentErrorMessage()
        if (message) {
          this.showError = true
          return this.$t(element.getPaymentErrorMessage(), element.getMinMaxValue())
        }
      }
      this.showError = false
      return ''
    },
    confirmActiveStake: function (eventData) {
      Vue.set(eventData, 'isDeleted', false)
      this.picks.push(eventData)
      this.sortTickerts()
      eventBus.onChangedPicksLength(this.picks.length)
    },
    deleteAll: function () {
      this.picks.forEach(v => {
        this.removePickedMatch(v)
      })
      setTimeout(() => {
        this.money = this.minValue
      })
    },
    removePickedMatch: function (match) {
      eventBus.removePickedMatch(match)
      this.picks = this.picks.filter(m => m !== match)
      this.sortTickerts()

      eventBus.onChangedPicksLength(this.picks.length)
    },
    markMatchAsDeleted: function (match) {
      let matchNo = this.extractMatchNo(match)
      this.picks.forEach(e => {
        if (this.extractMatchNo(e) === matchNo) {
          e.isDeleted = true
        }
      })
    }
  },
  computed: {
    numberOfItems: function () {
      return this.picks.length === 0 ? 1 : this.picks.length
    },
    maxValue: function () {
      return this.getMaxValue(this.config, this.numberOfItems)
    },
    minValue: function () {
      return this.getMinValue(this.config, this.numberOfItems)
    }
  },
  created: function () {
    eventBus.$on(EventConstants.VSOCCER_CONFIRM_ACTIVE_STAKE, this.confirmActiveStake)
    eventBus.$on(EventConstants.VSOCCER_DISABLE_BETTING_MATCH, this.markMatchAsDeleted)
  },
  beforeDestroy () {
    eventBus.$off(EventConstants.VSOCCER_CONFIRM_ACTIVE_STAKE, this.confirmActiveStake)
    eventBus.$off(EventConstants.VSOCCER_DISABLE_BETTING_MATCH, this.markMatchAsDeleted)
  }
}
</script>
